
const m = window.require("com.squareup.calc.Calc");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
